// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bg {
  background: linear-gradient(to right, #5721bf 0%, #5b2eb3 100%);
}

.intro-section {
  padding-top: 70px;
  padding-left: 52px;
}

h1 {
  color: #ffffff;
  text-align: left;
}

.section-heading .butons {
  font-size: 14px;
  margin-left: 15px;
  display: inline-block;
  vertical-align: middle;
}

.section-heading span {
  font-size: 14px;
  margin-left: 15px;
  display: inline-block;
  vertical-align: middle;
  padding: 10px;
  cursor: pointer;
}

.cat-list span,
.cat-list label {
  color: #fff;
  padding: 5px 10px;
  border: 1px solid #fff;
  border-radius: 26px;
  font-size: 14px;
  display: inline-block;
  cursor: pointer;
  margin: 7px;
  position: relative;
}

.cat-list input {
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9;
  cursor: pointer;
  width: 0;
}

.cat-list span.active,
.cat-list label.active,
.cat-list span:hover {
  background-color: #fff;
  color: #000;
}

.butons div {
  padding: 15px 20px;
  display: inline-block;
  border: 1px solid #fff;
}

.butons div.active {
  background-color: #fff;
  color: #000;
}

h1.section-heading {
  margin-bottom: 25px;
  margin-top: 50px;
}

.intro {
  background-color: #522195;
  color: #ffffff;
  border-radius: 12px;
  padding: 15px;
  height: auto;
  box-shadow: 2px 2px 3px 0px rgba(0, 0, 0, 0.4);
  overflow: hidden;
}

.intro img {
  width: 15%;
}

.intro div.d-table {
  width: 85%;
  float: right;
  padding-left: 15%;
}

.video-bg {
  background-image: url('feature-video.png');
  background-repeat: no-repeat;
  background-size: cover;
  height: auto;
}

/* Feature Video Section CSS */

.feature-video-section {
  margin-top: 50px;
  margin-bottom: 50px;
  padding-left: 52px;
}

.feature-video img.poster {
  width: 100%;
  height: 400px;
  object-fit: fill;
}

.feature-video .feature-info {
  position: absolute;
  z-index: 9;
  padding: 15px;
  color: #ffffff;
  bottom: 40px;
  /* background-color: black; */
}

.feature-video .feature-info h2 {
  margin-bottom: 25px;
  cursor: pointer;
}

.feature-video .feature-info p {
}

.feature-video .feature-info .categories {
  /* background-color: red; */
  padding: 10px 0px;
  height: auto;
}

.feature-video .feature-info .categories span.category {
  text-transform: uppercase;
  border: 1px solid #ffffff;
  padding: 3px 10px;
  margin-right: 10px;
  border-radius: 16px;
  display: inline-block;
  font-size: 14px;
}

.feature-video .feature-info .decision-info img {
  width: 30px;
  height: 30px;
  margin-right: 15px;
}

.feature-video .feature-info .btn-interact {
  background-color: #ffffff;
  color: #522195;
  margin-right: 15px;
  padding: 6px 15px;
}

.feature-video .feature-info .btn-outcomes {
  background-color: transparent;
  color: #ffffff;
  border: 1px solid #ffffff;
  padding: 6px 15px;
}

/* Feature Video Section CSS */

/* Trending Section CSS */

.trending-section {
  margin-top: 50px;
  margin-bottom: 50px;
  padding-left: 52px;
}

.cat-list {
  max-width: 1994px;
  white-space: nowrap;
  position: relative;
  padding-left: 25px;
  padding-right: 25px;
}

.trending-section h4.section-heading {
  color: #ffffff;
  margin-bottom: 10px;
}

.container-fluid {
  margin-bottom: 30px;
}

.trending-video img.poster {
  width: 100%;
  height: 35vh !important;
  object-fit: cover;
}

.trending-video:hover .video-info {
  top: 0;
}

.trending-video:hover .top-choices {
  opacity: 1;
  z-index: 9;
}

.interact-cardimg-iconstext {
  width: 120px;
  border-radius: 2px;
  padding: 10px 10px;
  position: absolute;
  top: 0px;
  right: 15px;
}

.interact-cardimg-iconstext > span {
  background-color: #ffffff;
  border-radius: 5px;
  padding: 3px;
}

.interact-cardimg-iconstext > span img {
  width: 20px !important;
  height: 20px;
  margin-right: 5px;
}

.interact-cardimg-iconstext > span b {
  font-size: 12px;
}

.trending-video .video-info {
  position: absolute;
  bottom: 0px;
  color: #ffffff;
  padding: 10px;
  background: rgba(0, 0, 0, 0.5);
  width: calc(100% - 30px);
}

.trending-video .video-info p {
  display: inline;
  word-break: break-all;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

.section-heading span {
  opacity: 0;
}

.addNewss {
  border: 1px solid #fff;
  padding: 5px;
}

#left-button,
#right-button {
  width: 25px;
  border: 1px solid #fff;
  border-radius: 2px;
  padding: 4px 5px;
  cursor: pointer;
  background: transparent;
  position: absolute;
  top: 6px;
  z-index: 99;
  background: #5721bf;
}

.scroller {
  overflow: auto;
}

#left-button img,
#right-button img {
  width: 12px;
}

#left-button:hover,
#right-button:hover {
  border: 2px solid #fff;
}

#left-button {
  left: 0;
}

#right-button {
  right: 0;
}

.oadmon {
  width: 100%;
  text-align: center;
  /* margin-right: 5px; */
  color: #fff;
  padding: 10px;
  cursor: pointer;
}

.cat-list input.addNewss {
  border: 1px solid #fff;
  color: #fff;
  background: transparent;
  width: 69px;
  position: relative;
  opacity: 1;
  font-size: 14px;
}

.section-heading span {
  opacity: 0;
}

.container-fluid:hover .section-heading span {
  opacity: 1;
}

.feature-video {
  position: relative;
}

.feature-video::before {
  position: absolute;
  content: "";
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9;
  background-color: rgba(0, 0, 0, 0.2);
}

.trending-video .video-info h6 {
  margin-top: 10px;
  margin-bottom: 0px;
  font-size: 1rem;
}

.trending-video .top-choices {
  position: absolute;
  color: #ffffff;
  padding: 10px;
  background: rgba(0, 0, 0, 0.5);
  width: calc(100% - 30px);
  bottom: 0px;
  opacity: 0;
}

.trending-video .top-choices .pro-group {
  margin-bottom: 10px;
}

.trending-video .top-choices .pro-group h6 {
  font-weight: normal;
  font-size: 12px;
}

.trending-video .top-choices .pro-group .progress {
  height: 6px;
}

.trending-video .top-choices .pro-group .progress .progress-bar {
  background-color: #522195;
}

/* Trending Section CSS */

.profile-25 {
  width: 40px !important;
  height: 40px !important;
  margin-right: 5px !important;
  object-fit: cover;
  cursor: pointer;
  border: 2px solid #ffffff;
  border-radius: 50%;
}

/* Highly Interactive Section CSS */

.highly-interactive-section {
  margin-top: 50px;
  margin-bottom: 50px;
  padding-left: 52px;
}

.highly-interactive-section h4.section-heading {
  color: #ffffff;
  margin-bottom: 20px;
}

.interactive-video img.poster {
  width: 100%;
  height: 300px;
  position: relative;
  object-fit: cover;
}

.interactive-video .decisions {
  position: absolute;
  top: 0px;
  padding: 10px;
  color: #ffffff;
  background: rgba(0, 0, 0, 0.5);
  width: calc(100% - 30px);
}

.interactive-video .decisions p {
  margin-bottom: 0px;
}

.interactive-video .decisions .touch-icon {
  float: left;
  width: 40px;
  margin-right: 5px;
}

.interactive-video .decisions .touch-icon img {
  width: 40px;
  height: 40px;
}

.interactive-video .video-info {
  position: absolute;
  bottom: 0px;
  color: #ffffff;
  padding: 10px;
  background: rgba(0, 0, 0, 0.5);
  width: calc(100% - 30px);
}

.interactive-video .video-info p {
  display: inline;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

.interactive-video .video-info h6 {
  margin-top: 10px;
  margin-bottom: 0px;
  font-size: 1rem;
}

.owl-nav {
  opacity: 0 !important;
}

/* Highly Interactive Section CSS */

.container-fluid .owl-nav {
  opacity: 1 !important;
}

/* Latest Section CSS */

.latest-section {
  margin-top: 50px;
  margin-bottom: 50px;
  padding-left: 52px;
}

.latest-section h4.section-heading {
  color: #ffffff;
  margin-bottom: 20px;
}

.latest-video img.poster {
  width: 100%;
  height: 300px !important;
  object-fit: cover;
}

.latest-video .video-info {
  position: absolute;
  bottom: 0px;
  color: #ffffff;
  padding: 10px;
  background: rgba(0, 0, 0, 0.5);
  width: calc(100% - 30px);
}

.latest-video .video-info p {
  display: inline;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

.latest-video .video-info h6 {
  margin-top: 10px;
  margin-bottom: 0px;
  font-size: 1rem;
}

/* Latest Section CSS */

/* Popuplar Categories Section CSS */

.pop-categories-section {
  margin-top: 50px;
  margin-bottom: 50px;
  padding-left: 52px;
}

.pop-categories-section .section-heading {
  color: #ffffff;
  margin-bottom: 20px;
}

.pop-categories-section .pop-categories .card {
  height: 230px;
  margin-bottom: 20px;
  border: none;
  background: none;
  transition: all 0.2s linear;
  cursor: pointer;
}

.pop-categories-section .pop-categories .card:hover {
  transform: scale(1.1);
  box-shadow: 1px 1px 10px 2px black;
  z-index: 1;
}

.pop-categories .card .card-img-overlay {
  color: #ffffff;
  top: unset;
  bottom: 0px;
  padding: 12px;
}

.pop-categories .card .card-img-overlay h6,
.pop-categories .card .card-img-overlay span {
  margin-bottom: 0px;
  font-size: 14px;
}

.pop-categories .card .card-img-overlay h3 {
  font-size: 24px;
}

.pop-categories-section .pop-categories .card > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.pop-categories-section .pop-categories {
  margin-bottom: 50px;
}

@media (max-width: 991px) {
  .trending-video img.poster {
    height: 300px !important;
  }
  .section-heading .butons {
    margin-left: 0px;
  }
  .interact-vid-sec {
    padding: 30px 30px 0px !important;
  }
  .custom-height,
  .position-relative.pop5 {
    height: auto !important;
    margin-bottom: 30px;
  }
  .card-body {
    padding-bottom: 20px !important;
  }
  .margin-right-0-mobile {
    margin-right: 0px !important;
  }
  .intro-section,
  .feature-video-section,
  .highly-interactive-section,
  .trending-section,
  .latest-section,
  .pop-categories-section {
    padding-left: 0;
  }
  .intro {
    margin-bottom: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/beforeLogin/explore/explore.component.css"],"names":[],"mappings":"AAAA;EACE,+DAA+D;AACjE;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,aAAa;EACb,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,eAAe;EACf,QAAQ;AACV;;AAEA;;;EAGE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,0CAAiE;EACjE,4BAA4B;EAC5B,sBAAsB;EACtB,YAAY;AACd;;AAEA,8BAA8B;;AAE9B;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,cAAc;EACd,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;AACA;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,8BAA8B;;AAE9B,yBAAyB;;AAEzB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,wBAAwB;EACxB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yBAAyB;;AAEzB;EACE,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,mCAAmC;;AAEnC;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,cAAc;EACd,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,mCAAmC;;AAEnC;EACE,qBAAqB;AACvB;;AAEA,uBAAuB;;AAEvB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,uBAAuB;;AAEvB,oCAAoC;;AAEpC;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,UAAU;EACV,WAAW;EACX,aAAa;AACf;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iCAAiC;EACnC;EACA;;IAEE,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,+BAA+B;EACjC;EACA;IACE,4BAA4B;EAC9B;EACA;;;;;;IAME,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".bg {\r\n  background: linear-gradient(to right, #5721bf 0%, #5b2eb3 100%);\r\n}\r\n\r\n.intro-section {\r\n  padding-top: 70px;\r\n  padding-left: 52px;\r\n}\r\n\r\nh1 {\r\n  color: #ffffff;\r\n  text-align: left;\r\n}\r\n\r\n.section-heading .butons {\r\n  font-size: 14px;\r\n  margin-left: 15px;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n}\r\n\r\n.section-heading span {\r\n  font-size: 14px;\r\n  margin-left: 15px;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  padding: 10px;\r\n  cursor: pointer;\r\n}\r\n\r\n.cat-list span,\r\n.cat-list label {\r\n  color: #fff;\r\n  padding: 5px 10px;\r\n  border: 1px solid #fff;\r\n  border-radius: 26px;\r\n  font-size: 14px;\r\n  display: inline-block;\r\n  cursor: pointer;\r\n  margin: 7px;\r\n  position: relative;\r\n}\r\n\r\n.cat-list input {\r\n  opacity: 0;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  z-index: 9;\r\n  cursor: pointer;\r\n  width: 0;\r\n}\r\n\r\n.cat-list span.active,\r\n.cat-list label.active,\r\n.cat-list span:hover {\r\n  background-color: #fff;\r\n  color: #000;\r\n}\r\n\r\n.butons div {\r\n  padding: 15px 20px;\r\n  display: inline-block;\r\n  border: 1px solid #fff;\r\n}\r\n\r\n.butons div.active {\r\n  background-color: #fff;\r\n  color: #000;\r\n}\r\n\r\nh1.section-heading {\r\n  margin-bottom: 25px;\r\n  margin-top: 50px;\r\n}\r\n\r\n.intro {\r\n  background-color: #522195;\r\n  color: #ffffff;\r\n  border-radius: 12px;\r\n  padding: 15px;\r\n  height: auto;\r\n  box-shadow: 2px 2px 3px 0px rgba(0, 0, 0, 0.4);\r\n  overflow: hidden;\r\n}\r\n\r\n.intro img {\r\n  width: 15%;\r\n}\r\n\r\n.intro div.d-table {\r\n  width: 85%;\r\n  float: right;\r\n  padding-left: 15%;\r\n}\r\n\r\n.video-bg {\r\n  background-image: url(\"../../../assets/images/feature-video.png\");\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n  height: auto;\r\n}\r\n\r\n/* Feature Video Section CSS */\r\n\r\n.feature-video-section {\r\n  margin-top: 50px;\r\n  margin-bottom: 50px;\r\n  padding-left: 52px;\r\n}\r\n\r\n.feature-video img.poster {\r\n  width: 100%;\r\n  height: 400px;\r\n  object-fit: fill;\r\n}\r\n\r\n.feature-video .feature-info {\r\n  position: absolute;\r\n  z-index: 9;\r\n  padding: 15px;\r\n  color: #ffffff;\r\n  bottom: 40px;\r\n  /* background-color: black; */\r\n}\r\n\r\n.feature-video .feature-info h2 {\r\n  margin-bottom: 25px;\r\n  cursor: pointer;\r\n}\r\n\r\n.feature-video .feature-info p {\r\n}\r\n\r\n.feature-video .feature-info .categories {\r\n  /* background-color: red; */\r\n  padding: 10px 0px;\r\n  height: auto;\r\n}\r\n\r\n.feature-video .feature-info .categories span.category {\r\n  text-transform: uppercase;\r\n  border: 1px solid #ffffff;\r\n  padding: 3px 10px;\r\n  margin-right: 10px;\r\n  border-radius: 16px;\r\n  display: inline-block;\r\n  font-size: 14px;\r\n}\r\n\r\n.feature-video .feature-info .decision-info img {\r\n  width: 30px;\r\n  height: 30px;\r\n  margin-right: 15px;\r\n}\r\n\r\n.feature-video .feature-info .btn-interact {\r\n  background-color: #ffffff;\r\n  color: #522195;\r\n  margin-right: 15px;\r\n  padding: 6px 15px;\r\n}\r\n\r\n.feature-video .feature-info .btn-outcomes {\r\n  background-color: transparent;\r\n  color: #ffffff;\r\n  border: 1px solid #ffffff;\r\n  padding: 6px 15px;\r\n}\r\n\r\n/* Feature Video Section CSS */\r\n\r\n/* Trending Section CSS */\r\n\r\n.trending-section {\r\n  margin-top: 50px;\r\n  margin-bottom: 50px;\r\n  padding-left: 52px;\r\n}\r\n\r\n.cat-list {\r\n  max-width: 1994px;\r\n  white-space: nowrap;\r\n  position: relative;\r\n  padding-left: 25px;\r\n  padding-right: 25px;\r\n}\r\n\r\n.trending-section h4.section-heading {\r\n  color: #ffffff;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.container-fluid {\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.trending-video img.poster {\r\n  width: 100%;\r\n  height: 35vh !important;\r\n  object-fit: cover;\r\n}\r\n\r\n.trending-video:hover .video-info {\r\n  top: 0;\r\n}\r\n\r\n.trending-video:hover .top-choices {\r\n  opacity: 1;\r\n  z-index: 9;\r\n}\r\n\r\n.interact-cardimg-iconstext {\r\n  width: 120px;\r\n  border-radius: 2px;\r\n  padding: 10px 10px;\r\n  position: absolute;\r\n  top: 0px;\r\n  right: 15px;\r\n}\r\n\r\n.interact-cardimg-iconstext > span {\r\n  background-color: #ffffff;\r\n  border-radius: 5px;\r\n  padding: 3px;\r\n}\r\n\r\n.interact-cardimg-iconstext > span img {\r\n  width: 20px !important;\r\n  height: 20px;\r\n  margin-right: 5px;\r\n}\r\n\r\n.interact-cardimg-iconstext > span b {\r\n  font-size: 12px;\r\n}\r\n\r\n.trending-video .video-info {\r\n  position: absolute;\r\n  bottom: 0px;\r\n  color: #ffffff;\r\n  padding: 10px;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  width: calc(100% - 30px);\r\n}\r\n\r\n.trending-video .video-info p {\r\n  display: inline;\r\n  word-break: break-all;\r\n  font-size: 1rem;\r\n  font-weight: 400;\r\n  line-height: 1.5;\r\n}\r\n\r\n.section-heading span {\r\n  opacity: 0;\r\n}\r\n\r\n.addNewss {\r\n  border: 1px solid #fff;\r\n  padding: 5px;\r\n}\r\n\r\n#left-button,\r\n#right-button {\r\n  width: 25px;\r\n  border: 1px solid #fff;\r\n  border-radius: 2px;\r\n  padding: 4px 5px;\r\n  cursor: pointer;\r\n  background: transparent;\r\n  position: absolute;\r\n  top: 6px;\r\n  z-index: 99;\r\n  background: #5721bf;\r\n}\r\n\r\n.scroller {\r\n  overflow: auto;\r\n}\r\n\r\n#left-button img,\r\n#right-button img {\r\n  width: 12px;\r\n}\r\n\r\n#left-button:hover,\r\n#right-button:hover {\r\n  border: 2px solid #fff;\r\n}\r\n\r\n#left-button {\r\n  left: 0;\r\n}\r\n\r\n#right-button {\r\n  right: 0;\r\n}\r\n\r\n.oadmon {\r\n  width: 100%;\r\n  text-align: center;\r\n  /* margin-right: 5px; */\r\n  color: #fff;\r\n  padding: 10px;\r\n  cursor: pointer;\r\n}\r\n\r\n.cat-list input.addNewss {\r\n  border: 1px solid #fff;\r\n  color: #fff;\r\n  background: transparent;\r\n  width: 69px;\r\n  position: relative;\r\n  opacity: 1;\r\n  font-size: 14px;\r\n}\r\n\r\n.section-heading span {\r\n  opacity: 0;\r\n}\r\n\r\n.container-fluid:hover .section-heading span {\r\n  opacity: 1;\r\n}\r\n\r\n.feature-video {\r\n  position: relative;\r\n}\r\n\r\n.feature-video::before {\r\n  position: absolute;\r\n  content: \"\";\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  z-index: 9;\r\n  background-color: rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.trending-video .video-info h6 {\r\n  margin-top: 10px;\r\n  margin-bottom: 0px;\r\n  font-size: 1rem;\r\n}\r\n\r\n.trending-video .top-choices {\r\n  position: absolute;\r\n  color: #ffffff;\r\n  padding: 10px;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  width: calc(100% - 30px);\r\n  bottom: 0px;\r\n  opacity: 0;\r\n}\r\n\r\n.trending-video .top-choices .pro-group {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.trending-video .top-choices .pro-group h6 {\r\n  font-weight: normal;\r\n  font-size: 12px;\r\n}\r\n\r\n.trending-video .top-choices .pro-group .progress {\r\n  height: 6px;\r\n}\r\n\r\n.trending-video .top-choices .pro-group .progress .progress-bar {\r\n  background-color: #522195;\r\n}\r\n\r\n/* Trending Section CSS */\r\n\r\n.profile-25 {\r\n  width: 40px !important;\r\n  height: 40px !important;\r\n  margin-right: 5px !important;\r\n  object-fit: cover;\r\n  cursor: pointer;\r\n  border: 2px solid #ffffff;\r\n  border-radius: 50%;\r\n}\r\n\r\n/* Highly Interactive Section CSS */\r\n\r\n.highly-interactive-section {\r\n  margin-top: 50px;\r\n  margin-bottom: 50px;\r\n  padding-left: 52px;\r\n}\r\n\r\n.highly-interactive-section h4.section-heading {\r\n  color: #ffffff;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.interactive-video img.poster {\r\n  width: 100%;\r\n  height: 300px;\r\n  position: relative;\r\n  object-fit: cover;\r\n}\r\n\r\n.interactive-video .decisions {\r\n  position: absolute;\r\n  top: 0px;\r\n  padding: 10px;\r\n  color: #ffffff;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  width: calc(100% - 30px);\r\n}\r\n\r\n.interactive-video .decisions p {\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.interactive-video .decisions .touch-icon {\r\n  float: left;\r\n  width: 40px;\r\n  margin-right: 5px;\r\n}\r\n\r\n.interactive-video .decisions .touch-icon img {\r\n  width: 40px;\r\n  height: 40px;\r\n}\r\n\r\n.interactive-video .video-info {\r\n  position: absolute;\r\n  bottom: 0px;\r\n  color: #ffffff;\r\n  padding: 10px;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  width: calc(100% - 30px);\r\n}\r\n\r\n.interactive-video .video-info p {\r\n  display: inline;\r\n  font-size: 1rem;\r\n  font-weight: 400;\r\n  line-height: 1.5;\r\n}\r\n\r\n.interactive-video .video-info h6 {\r\n  margin-top: 10px;\r\n  margin-bottom: 0px;\r\n  font-size: 1rem;\r\n}\r\n\r\n.owl-nav {\r\n  opacity: 0 !important;\r\n}\r\n\r\n/* Highly Interactive Section CSS */\r\n\r\n.container-fluid .owl-nav {\r\n  opacity: 1 !important;\r\n}\r\n\r\n/* Latest Section CSS */\r\n\r\n.latest-section {\r\n  margin-top: 50px;\r\n  margin-bottom: 50px;\r\n  padding-left: 52px;\r\n}\r\n\r\n.latest-section h4.section-heading {\r\n  color: #ffffff;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.latest-video img.poster {\r\n  width: 100%;\r\n  height: 300px !important;\r\n  object-fit: cover;\r\n}\r\n\r\n.latest-video .video-info {\r\n  position: absolute;\r\n  bottom: 0px;\r\n  color: #ffffff;\r\n  padding: 10px;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  width: calc(100% - 30px);\r\n}\r\n\r\n.latest-video .video-info p {\r\n  display: inline;\r\n  font-size: 1rem;\r\n  font-weight: 400;\r\n  line-height: 1.5;\r\n}\r\n\r\n.latest-video .video-info h6 {\r\n  margin-top: 10px;\r\n  margin-bottom: 0px;\r\n  font-size: 1rem;\r\n}\r\n\r\n/* Latest Section CSS */\r\n\r\n/* Popuplar Categories Section CSS */\r\n\r\n.pop-categories-section {\r\n  margin-top: 50px;\r\n  margin-bottom: 50px;\r\n  padding-left: 52px;\r\n}\r\n\r\n.pop-categories-section .section-heading {\r\n  color: #ffffff;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.pop-categories-section .pop-categories .card {\r\n  height: 230px;\r\n  margin-bottom: 20px;\r\n  border: none;\r\n  background: none;\r\n  transition: all 0.2s linear;\r\n  cursor: pointer;\r\n}\r\n\r\n.pop-categories-section .pop-categories .card:hover {\r\n  transform: scale(1.1);\r\n  box-shadow: 1px 1px 10px 2px black;\r\n  z-index: 1;\r\n}\r\n\r\n.pop-categories .card .card-img-overlay {\r\n  color: #ffffff;\r\n  top: unset;\r\n  bottom: 0px;\r\n  padding: 12px;\r\n}\r\n\r\n.pop-categories .card .card-img-overlay h6,\r\n.pop-categories .card .card-img-overlay span {\r\n  margin-bottom: 0px;\r\n  font-size: 14px;\r\n}\r\n\r\n.pop-categories .card .card-img-overlay h3 {\r\n  font-size: 24px;\r\n}\r\n\r\n.pop-categories-section .pop-categories .card > img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n}\r\n\r\n.pop-categories-section .pop-categories {\r\n  margin-bottom: 50px;\r\n}\r\n\r\n@media (max-width: 991px) {\r\n  .trending-video img.poster {\r\n    height: 300px !important;\r\n  }\r\n  .section-heading .butons {\r\n    margin-left: 0px;\r\n  }\r\n  .interact-vid-sec {\r\n    padding: 30px 30px 0px !important;\r\n  }\r\n  .custom-height,\r\n  .position-relative.pop5 {\r\n    height: auto !important;\r\n    margin-bottom: 30px;\r\n  }\r\n  .card-body {\r\n    padding-bottom: 20px !important;\r\n  }\r\n  .margin-right-0-mobile {\r\n    margin-right: 0px !important;\r\n  }\r\n  .intro-section,\r\n  .feature-video-section,\r\n  .highly-interactive-section,\r\n  .trending-section,\r\n  .latest-section,\r\n  .pop-categories-section {\r\n    padding-left: 0;\r\n  }\r\n  .intro {\r\n    margin-bottom: 20px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
